import React, { Component } from "react";

import data from "currency-codes/data";

import { Formik, Form } from "formik";
import { TextInput, SelectInput } from "../../../../forms/components";

import {
	addMID,
	removeMID,
	regenKey,
	regenRMSKey,
	ipay88Key,
	applicationCodeRMS,
	applicationV2keyUQPay,
	secretKeyNetzme,
} from "../../../../libs/functions";
import Util from "../../../../libs/util";

import { editDetails } from "../../../../libs/functions";

import Swal from "sweetalert2";

class ManageMerchantIdentification extends Component {
	constructor(props) {
		super(props);

		const priorityCode = ["SGD", "MYR", "USD"];
		const codes = [
			...data.filter((i) => priorityCode.includes(i.code)),
			...data.filter((i) => !priorityCode.includes(i.code)),
		];

		this.state = {
			type: null,
			currency: [
				...codes.map((d) => {
					return { name: d.code, value: d.number };
				}),
			],
			initialValues: {},
			currentVersionType: 3,
			currentVersionTypeUqpay: 1,
		};

		this.addMIDModalRef = React.createRef();
		this.regenKeyModalRef = React.createRef();
		this.ipay88KeyModalRef = React.createRef();
		this.regenRMSKeyModalRef = React.createRef();
		this.applicationRMSCodeModalRef = React.createRef();
		this.uqPayKeyModalRef = React.createRef();
		this.netzmeKeyModalRef = React.createRef();
	}

	componentDidMount() {
		this.setState({ currentVersionType: this.props.merchant.tctpVersion });
		this.setState({
			currentVersionTypeUqpay: this.props.merchant.uqpayVersion,
		});
	}

	_viewAddMID = (type) => {
		let initialValues = {};
		initialValues[type] = {};
		initialValues[type].code = "";
		initialValues[type].mid = "";

		this.setState({ type: type, initialValues: initialValues }, () => {
			Util.showModal("add-mid");
		});
	};

	_viewRegenKey = () => {
		Util.showModal("regen-key");
	};

	// RMS
	_viewRegenRMSKey = () => {
		Util.showModal("regen-rms-key");
	};

	_viewApplicationRMSKey = () => {
		Util.showModal("application-rms-key");
	};

	_viewUQPayOpenModal = () => {
		Util.showModal("uqpay-key");
	};

	_viewIPay88Key = () => {
		Util.showModal("ipay88-key");
	};

	_viewNetzmeKey = () => {
		Util.showModal("netzme-key");
	};

	_addMID = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: "Adding MID",
			allowOutsideClick: () => !Swal.isLoading(),
			onBeforeOpen: async () => {
				await Util.hideModal("add-mid");
			},
			onOpen: async () => {
				try {
					let status = await addMID(this.props.merchant.id, {
						payload: values,
					});
					Swal.hideLoading();
					setSubmitting(false);
					if (status) {
						Swal.fire({
							icon: "success",
							title: "MID Added",
						}).then(async () => {
							this.props.retrieveMerchants(true);
							resetForm();
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to Add MID",
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to Add MID`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	_regenKey = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: "Regenerating Keys",
			allowOutsideClick: () => !Swal.isLoading(),
			onBeforeOpen: async () => {
				await Util.hideModal("regen-key");
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					const {
						regenerate: { mid, authKey, shaKey },
					} = values;
					let data = await regenKey(mid, authKey, shaKey);
					Swal.hideLoading();
					setSubmitting(false);
					if (data) {
						Swal.fire({
							icon: "success",
							title: "Key Regenerated",
						}).then(async () => {
							Util.downloadFile(data, `cert.crt - ${mid}.txt`);
							this.props.retrieveMerchants(true);
							resetForm();
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to regenerate key",
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to regenerate key`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	_removeMID = (type, currency) => {
		Swal.fire({
			title: "Removing MID",
			allowOutsideClick: () => !Swal.isLoading(),
			onOpen: async () => {
				try {
					let status = await removeMID(this.props.merchant.id, type, currency);
					Swal.hideLoading();
					if (status) {
						Swal.fire({
							icon: "success",
							title: "MID Removed",
						}).then(async () => {
							this.props.retrieveMerchants(true);
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to Remove MID",
						});
					}
				} catch (err) {
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to Remove MID`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	_ipay88Key = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: "Setting Merchant Key",
			allowOutsideClick: () => !Swal.isLoading(),
			onBeforeOpen: async () => {
				await Util.hideModal("ipay88-key");
			},
			onOpen: async () => {
				try {
					let status = await ipay88Key(this.props.merchant.id, {
						payload: values,
					});
					Swal.hideLoading();
					setSubmitting(false);
					if (status) {
						Swal.fire({
							icon: "success",
							title: "Merchant Key Set",
						}).then(async () => {
							this.props.retrieveMerchants(true);
							resetForm();
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to set Merchant Key",
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to set Merchant Key`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	// UQ pay details
	_viewUQpayKey = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: "Setting Transaction And Notification Key",
			allowOutsideClick: () => !Swal.isLoading(),
			onBeforeOpen: async () => {
				await Util.hideModal("uqpay-key");
			},
			onOpen: async () => {
				try {
					let status = await applicationV2keyUQPay(this.props.merchant.id, {
						payload: values,
					});
					Swal.hideLoading();
					setSubmitting(false);
					if (status) {
						Swal.fire({
							icon: "success",
							title: "Transaction And Notification Key Set",
						}).then(async () => {
							this.props.retrieveMerchants(true);
							resetForm();
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to set Transaction And Notification Key",
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to set Transaction And Notification Key`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	// Application RMS Code
	_applicationRMSKey = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: "Setting Application Code",
			allowOutsideClick: () => !Swal.isLoading(),
			onBeforeOpen: async () => {
				await Util.hideModal("application-rms-key");
			},
			onOpen: async () => {
				try {
					let status = await applicationCodeRMS(this.props.merchant.id, {
						payload: values,
					});
					Swal.hideLoading();
					setSubmitting(false);
					if (status) {
						Swal.fire({
							icon: "success",
							title: "Application Code Set",
						}).then(async () => {
							this.props.retrieveMerchants(true);
							resetForm();
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to set Application Code",
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to set Application Code`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	// RMS
	_regenRMSKey = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: "Regenerating RMS Keys",
			allowOutsideClick: () => !Swal.isLoading(),
			onBeforeOpen: async () => {
				await Util.hideModal("regen-rms-key");
				// Swal.showLoading();
			},
			onOpen: async () => {
				try {
					const {
						regenerate: { mid, verifyKey, secretKey },
					} = values;
					let data = await regenRMSKey(mid, verifyKey, secretKey);
					Swal.hideLoading();
					setSubmitting(false);
					if (data) {
						Swal.fire({
							icon: "success",
							title: "RMS Key Regenerated",
						}).then(async () => {
							// Util.downloadFile(data, `cert.crt - ${mid}.txt`);
							this.props.retrieveMerchants(true);
							resetForm();
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to regenerate RMS key",
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to regenerate key`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	// Netzme
	_netzMeKey = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: "Setting Key",
			allowOutsideClick: () => !Swal.isLoading(),
			onBeforeOpen: async () => {
				await Util.hideModal("netzme-key");
			},
			onOpen: async () => {
				try {
					console.log(`netzme edit key START`);
					let status = await secretKeyNetzme(this.props.merchant.id, {
						payload: values,
					});
					Swal.hideLoading();
					setSubmitting(false);
					if (status) {
						Swal.fire({
							icon: "success",
							title: "Key Netzme Set",
						}).then(async () => {
							this.props.retrieveMerchants(true);
							resetForm();
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to set Key Netzme",
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to set Key Netzme`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	onVersionChange = (e) => {
		let value = e.target.value;
		Swal.fire({
			title: "Editing Version",
			allowOutsideClick: () => !Swal.isLoading(),
			onBeforeOpen: async () => {
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					let status = await editDetails({
						id: this.props.merchant.id,
						tctpVersion: parseInt(value),
					});
					Swal.hideLoading();

					if (status) {
						Swal.fire({
							icon: "success",
							title: "Version Updated",
						}).then(() => {
							this.setState({ currentVersionType: value });
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to Update Version",
						});
					}
				} catch (err) {
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to Update Version`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	onVersionChangeUqpay = (e) => {
		let value = e.target.value;
		Swal.fire({
			title: "Editing Version",
			allowOutsideClick: () => !Swal.isLoading(),
			onBeforeOpen: async () => {
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					let status = await editDetails({
						id: this.props.merchant.id,
						uqpayVersion: parseInt(value),
					});
					Swal.hideLoading();

					if (status) {
						Swal.fire({
							icon: "success",
							title: "Version Updated",
						}).then(() => {
							this.setState({ currentVersionTypeUqpay: value });
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to Update Version",
						});
					}
				} catch (err) {
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to Update Version`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	render() {
		const { merchant, readOnly, gateway, master } = this.props;
		console.log("merchant", merchant);
		const { currency, type, initialValues } = this.state;
		console.log("tyopes", type);
		return (
			<div className="info-mid">
				<h4 className="uk-margin-remove">
					<span className="uk-flex uk-flex-middle">
						<i
							className="uk-margin-small-right form-header-icon"
							uk-icon="icon: fa-solid-fingerprint; ratio: 0.9"
						/>
						Identification
					</span>
					<hr className="uk-margin-small-top uk-margin-small-bottom" />
				</h4>

				{Object.keys(gateway).map((key) => {
					let mids = merchant.midv2[key] || null;
					return (
						<table
							key={key}
							className="uk-table uk-table-divider uk-table-striped uk-margin-medium-bottom"
						>
							<caption className="uk-text-uppercase uk-text-bold uk-margin-small-bottom">
								<img
									className="uk-img"
									src={`data:image/*;base64,${gateway[key].image}`}
									width="25"
								/>
								<span className="uk-margin-small-left">
									{gateway[key].name}
								</span>
								{!readOnly && (
									<button
										className="uk-margin-left uk-icon-button uk-button-primary"
										uk-icon="icon: fa-solid-plus-circle; ratio: 0.5"
										type="button"
										onClick={() => this._viewAddMID(key)}
									/>
								)}
								{master && key == "tctp" && (
									<button
										className="uk-margin-left uk-icon-button uk-button-primary"
										uk-icon="icon: fa-solid-key; ratio: 0.5"
										type="button"
										onClick={() => this._viewRegenKey(key)}
									/>
								)}
								{master && key == "uqpay" && (
									<>
										<button
											className="uk-margin-left uk-icon-button uk-button-primary"
											uk-icon="icon: fa-solid-key; ratio: 0.5"
											type="button"
											onClick={() => this._viewUQPayOpenModal(key)}
										/>
									</>
								)}
								{master && key == "ipay88" && (
									<button
										className="uk-margin-left uk-icon-button uk-button-primary"
										uk-icon="icon: fa-solid-key; ratio: 0.5"
										type="button"
										onClick={() => this._viewIPay88Key(key)}
									/>
								)}
								{master && key == "rms" && (
									<>
										<button
											className="uk-margin-left uk-icon-button uk-button-primary"
											uk-icon="icon: fa-solid-key; ratio: 0.5"
											type="button"
											onClick={() => this._viewRegenRMSKey(key)}
										/>
										<button
											className="uk-margin-left uk-icon-button uk-button-primary"
											uk-icon="icon: fa-solid-key; ratio: 0.5"
											type="button"
											onClick={() => this._viewApplicationRMSKey(key)}
										/>
									</>
								)}
								{master && key == "netzme" && (
									<>
										<button
											className="uk-margin-left uk-icon-button uk-button-primary"
											uk-icon="icon: fa-solid-key; ratio: 0.5"
											type="button"
											onClick={() => this._viewNetzmeKey(key)}
										/>
									</>
								)}
								{master && key == "tctp" && (
									<div
										className="uk-margin-left uk-width-1-4@s"
										style={{
											display: "flex",
											alignItems: "center",
											float: "right",
										}}
									>
										<label className="uk-form-label uk-margin-right">
											Version
										</label>
										<select
											className="uk-select"
											onChange={this.onVersionChange}
											value={this.state.currentVersionType}
										>
											<option key={4} value={4} className="uk-text-capitalize">
												4
											</option>
											<option key={3} value={3} className="uk-text-capitalize">
												3
											</option>
										</select>
									</div>
								)}
								{master && key == "uqpay" && (
									<div
										className="uk-margin-left uk-width-1-4@s"
										style={{
											display: "flex",
											alignItems: "center",
											float: "right",
										}}
									>
										<label className="uk-form-label uk-margin-right">
											Version
										</label>
										<select
											className="uk-select"
											onChange={this.onVersionChangeUqpay}
											value={this.state.currentVersionTypeUqpay}
										>
											<option key={2} value={2} className="uk-text-capitalize">
												2
											</option>
											<option key={1} value={1} className="uk-text-capitalize">
												1
											</option>
										</select>
									</div>
								)}
								{/* {!readOnly && (
									<button
										className="uk-margin-small-left uk-icon-button uk-button-primary"
										uk-icon="icon: fa-solid-pencil-alt; ratio: 0.5"
										type="button"
									/>
								)} */}
							</caption>
							{key == "ipay88" && merchant.ipay88MerchantKey && (
								<caption>
									<table
										className="uk-table uk-table-divider uk-table-striped"
										style={{ marginBottom: 0 }}
									>
										<thead>
											<tr>
												<th>Merchant Key</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td
													style={{
														fontSize: 16,
														fontWeight: 400,
														color: "#666",
													}}
												>
													{merchant.ipay88MerchantKey}
												</td>
											</tr>
										</tbody>
									</table>
								</caption>
							)}
							{key == "rms" && merchant.rmsApplicationCode && (
								<caption>
									<table
										className="uk-table uk-table-divider uk-table-striped"
										style={{ marginBottom: 0 }}
									>
										<thead>
											<tr>
												<th>Application Code</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td
													style={{
														fontSize: 16,
														fontWeight: 400,
														color: "#666",
													}}
												>
													{merchant.rmsApplicationCode}
												</td>
											</tr>
										</tbody>
									</table>
								</caption>
							)}
							{/* {key == "rms" && regenerate.mid && (
								<caption>
									<table
										className="uk-table uk-table-divider uk-table-striped"
										style={{ marginBottom: 0 }}
									>
										<thead>
											<tr>
												<th>Merchant Identification</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td
													style={{
														fontSize: 16,
														fontWeight: 400,
														color: "#666",
													}}
												>
													{regenerate.mid}
												</td>
											</tr>
										</tbody>
									</table>
								</caption>
							)} */}
							{mids && (
								<>
									<thead>
										<tr>
											{!readOnly && <th />}
											<th className="uk-width-1-4">Currency</th>
											<th>MID</th>
											{/* Only STORE ID */}
											{key === "rms" && <th>Store ID</th>}
										</tr>
									</thead>
									<tbody>
										{Object.keys(mids).map((currency) => {
											console.log("mids", mids);
											let storeId = merchant.rmsStoreId?.[currency] || null;
											return (
												<tr key={`${key}-${currency}`}>
													{!readOnly && (
														<td className="icon-column">
															<button
																className="uk-icon-button uk-button-danger"
																uk-icon="icon: fa-solid-minus; ratio: 0.5"
																type="button"
																onClick={() => this._removeMID(key, currency)}
															/>
														</td>
													)}
													<td>{Util.currencyNumToCode(currency)}</td>
													<td>
														{mids[currency]}
														<button
															className="uk-margin-left uk-icon-button-alt"
															uk-icon="icon: fa-regular-copy; ratio: 0.9"
															type="button"
															uk-tooltip="Copy to Clipboard"
															onClick={() =>
																Util.copyToClipboard(mids[currency])
															}
														/>
													</td>
													{/* Store ID only For RMS */}
													{key === "rms" && storeId && (
														<td>
															{storeId}
															<button
																className="uk-margin-left uk-icon-button-alt"
																uk-icon="icon: fa-regular-copy; ratio: 0.9"
																type="button"
																uk-tooltip="Copy to Clipboard"
																onClick={() => Util.copyToClipboard(storeId)}
															/>
														</td>
													)}
												</tr>
											);
										})}
									</tbody>
								</>
							)}
						</table>
					);
				})}
				<div id="add-mid" uk-modal="stack: true" ref={this.addMIDModalRef}>
					{type && (
						<div className="uk-modal-dialog uk-modal-body">
							<h2 className="uk-modal-title">
								Add MID for {gateway[type].name}
							</h2>
							<Formik initialValues={initialValues} onSubmit={this._addMID}>
								<Form className="uk-form-stacked">
									<div className="uk-grid-column-small uk-grid-row-medium uk-grid">
										<div className="uk-width-1-4">
											<SelectInput
												label="Currency"
												data={currency}
												id={`${type}.code`}
												name={`${type}.code`}
												initialEmpty={true}
											/>
										</div>
										<div className="uk-width-3-4">
											<TextInput
												label="Merchant Identification"
												id={`${type}.mid`}
												name={`${type}.mid`}
												type="text"
											/>
										</div>
										{type === "rms" && (
											<div className="uk-width-3-4">
												<TextInput
													label="Store ID"
													id={`${type}.rmsStoreId`}
													name={`${type}.rmsStoreId`}
													type="text"
												/>
											</div>
										)}
									</div>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default uk-modal-close"
											type="button"
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Add
										</button>
									</p>
								</Form>
							</Formik>
						</div>
					)}
				</div>
				{master && (
					<div
						id="regen-key"
						uk-modal="stack: true"
						ref={this.regenKeyModalRef}
					>
						<div className="uk-modal-dialog uk-modal-body">
							<h2 className="uk-modal-title">Regenerate 2C2P Keys</h2>
							<Formik initialValues={{}} onSubmit={this._regenKey}>
								<Form className="uk-form-stacked">
									<div className="uk-grid-column-small uk-grid-row-medium uk-grid">
										<div className="uk-width-3-4">
											<TextInput
												label="Merchant Identification"
												id={`regenerate.mid`}
												name={`regenerate.mid`}
												type="text"
											/>
										</div>
										<div className="uk-width-1-1">
											<TextInput
												label="Current Merchant Authentication Key: (Secret Key)"
												id={`regenerate.authKey`}
												name={`regenerate.authKey`}
												type="text"
											/>
										</div>
										<div className="uk-width-1-1">
											<TextInput
												label="Current Merchant SHA Key: (Secret Key)"
												id={`regenerate.shaKey`}
												name={`regenerate.shaKey`}
												type="text"
											/>
										</div>
									</div>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default uk-modal-close"
											type="button"
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Regenerate
										</button>
									</p>
								</Form>
							</Formik>
						</div>
					</div>
				)}
				{/* Key UQPAY */}
				{master && (
					<div
						id="uqpay-key"
						uk-modal="stack: true"
						ref={this.uqPayKeyModalRef}
					>
						<div className="uk-modal-dialog uk-modal-body">
							<h2 className="uk-modal-title">Change Key UQ PAY</h2>
							<Formik initialValues={{}} onSubmit={this._viewUQpayKey}>
								<Form className="uk-form-stacked">
									<div className="uk-grid-column-small uk-grid-row-medium uk-grid">
										<div className="uk-width-1-1">
											<TextInput
												label="Transaction Sign ID"
												id={`uqpayTransactionSignId`}
												name={`uqpayTransactionSignId`}
												type="text"
											/>
											<TextInput
												label="Transaction Sign Key"
												id={`uqpayTransactionSignKey`}
												name={`uqpayTransactionSignKey`}
												type="text"
											/>
											<TextInput
												label="Notification Sign ID"
												id={`uqpayNotificationSignId`}
												name={`uqpayNotificationSignId`}
												type="text"
											/>
											<TextInput
												label="Notification Sign Key"
												id={`uqpayNotificationSignKey`}
												name={`uqpayNotificationSignKey`}
												type="text"
											/>
										</div>
									</div>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default uk-modal-close"
											type="button"
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Submit
										</button>
									</p>
								</Form>
							</Formik>
						</div>
					</div>
				)}
				{master && (
					<div
						id="ipay88-key"
						uk-modal="stack: true"
						ref={this.ipay88KeyModalRef}
					>
						<div className="uk-modal-dialog uk-modal-body">
							<h2 className="uk-modal-title">Change IPay 88 Merchant Key</h2>
							<Formik initialValues={{}} onSubmit={this._ipay88Key}>
								<Form className="uk-form-stacked">
									<div className="uk-grid-column-small uk-grid-row-medium uk-grid">
										<div className="uk-width-1-1">
											<TextInput
												label="New Merchant Key"
												id={`ipay88MerchantKey`}
												name={`ipay88MerchantKey`}
												type="text"
											/>
										</div>
									</div>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default uk-modal-close"
											type="button"
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Submit
										</button>
									</p>
								</Form>
							</Formik>
						</div>
					</div>
				)}
				{master && (
					<div
						id="regen-rms-key"
						uk-modal="stack: true"
						ref={this.regenRMSKeyModalRef}
					>
						<div className="uk-modal-dialog uk-modal-body">
							<h2 className="uk-modal-title">Regenerate RMS Keys</h2>
							<Formik initialValues={{}} onSubmit={this._regenRMSKey}>
								<Form className="uk-form-stacked">
									<div className="uk-grid-column-small uk-grid-row-medium uk-grid">
										<div className="uk-width-3-4">
											<TextInput
												label="Merchant Identification"
												id={`regenerate.mid`}
												name={`regenerate.mid`}
												type="text"
											/>
										</div>
										<div className="uk-width-1-1">
											<TextInput
												label="Current Merchant Verify Key: (Secret Key):"
												id={`regenerate.verifyKey`}
												name={`regenerate.verifyKey`}
												type="text"
											/>
										</div>
										<div className="uk-width-1-1">
											<TextInput
												label="Current Merchant Secret Key: (Secret Key)"
												id={`regenerate.secretKey`}
												name={`regenerate.secretKey`}
												type="text"
											/>
										</div>
									</div>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default uk-modal-close"
											type="button"
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Regenerate
										</button>
									</p>
								</Form>
							</Formik>
						</div>
					</div>
				)}
				{/* Application Code RMS */}
				{master && (
					<div
						id="application-rms-key"
						uk-modal="stack: true"
						ref={this.applicationRMSCodeModalRef}
					>
						<div className="uk-modal-dialog uk-modal-body">
							<h2 className="uk-modal-title">Change Application Code</h2>
							<Formik initialValues={{}} onSubmit={this._applicationRMSKey}>
								<Form className="uk-form-stacked">
									<div className="uk-grid-column-small uk-grid-row-medium uk-grid">
										<div className="uk-width-1-1">
											<TextInput
												label="New Application Code"
												id={`rmsApplicationCode`}
												name={`rmsApplicationCode`}
												type="text"
											/>
										</div>
									</div>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default uk-modal-close"
											type="button"
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Submit
										</button>
									</p>
								</Form>
							</Formik>
						</div>
					</div>
				)}

				{/* Secret Netzme */}
				{master && (
					<div
						id="netzme-key"
						uk-modal="stack: true"
						ref={this.netzmeKeyModalRef}
					>
						<div className="uk-modal-dialog uk-modal-body">
							<h2 className="uk-modal-title">Update Netzme</h2>
							<Formik initialValues={{}} onSubmit={this._netzMeKey}>
								<Form className="uk-form-stacked">
									<div className="uk-grid-column-small uk-grid-row-medium uk-grid">
										<div className="uk-width-1-1">
											<TextInput
												label="Netzme Client ID"
												id={`netzme_clientId`}
												name={`netzme_clientId`}
												type="text"
											/>
										</div>
										<div className="uk-width-1-1">
											<TextInput
												label="Netzme Client Secret"
												id={`netzme_clientSecret`}
												name={`netzme_clientSecret`}
												type="text"
											/>
										</div>
										<div className="uk-width-1-1">
											<TextInput
												label="Netzme Private Key"
												id={`netzme_privateKey`}
												name={`netzme_privateKey`}
												type="text"
											/>
										</div>
									</div>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default uk-modal-close"
											type="button"
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Submit
										</button>
									</p>
								</Form>
							</Formik>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default ManageMerchantIdentification;
